import { api, getFromLocalStorage } from '@/shared'
import { actions } from './actions'
import { handbookActions } from '@/entity/handbook'
import { contractsThunks, userActions } from '@/entity'
import { message } from 'antd'
import { employerProfileThunks } from '@features/employerProfile/model'
import { companyActions } from '@/entity/company'
import { t } from 'i18next'

export const getEmployerActivityByBin = (payload) => {
	return async (dispatch) => {
		try {
			const data = await api.profile.getEmployerActivityByBIN({ bin: payload.code })
			dispatch(
				handbookActions.setSingleOptions({
					name: 'oked',
					data: {
						id: data.id,
						code: data.okedCode,
						rus: data.okedRu,
						kz: data.okedKz,
						fullNameKz: data.fullNameKz,
						fullNameRu: data.fullNameRu,
					},
				})
			)
		} catch (error) {}
	}
}

export const getEmployerActivityByIIN = (payload) => {
	return async (dispatch) => {
		try {
			const data = await dispatch(contractsThunks.getFLData({ data: { iin: payload.code } }))
			if (!data.fullNameIpKz && !data.fullNameIpRu) {
				alert(t('error_bin_or_iin'))
				return
			}
			dispatch(
				handbookActions.setSingleOptions({
					name: 'oked',
					data: {
						id: data.id,
						code: data.okedCode,
						rus: data.okedRu,
						kz: data.okedKz,
						fullNameKz: data.fullNameIpKz,
						fullNameRu: data.fullNameIpRu,
					},
				})
			)
		} catch (error) {}
	}
}

export const getEmployerActivityByIINAndBin = (payload) => {
	return async (dispatch) => {
		try {
			const data = await api.profile.getEmployerActivityByIINAndBin({ bin: payload.code })
			if (!data.fullNameKz && !data.fullNameRu) {
				alert(t('error_bin_or_iin'))
				return
			}
			dispatch(
				handbookActions.setSingleOptions({
					name: 'oked',
					data: {
						id: data.id,
						code: data.okedCode,
						rus: data.okedRu,
						kz: data.okedKz,
						fullNameKz: data.fullNameKz,
						fullNameRu: data.fullNameRu,
					},
				})
			)
		} catch (error) {}
	}
}

export const createEditUser = (payload) => {
	return async (dispatch) => {
		try {
			const response = await api.profile.createEditProfile(payload)
			dispatch(
				userActions.setUser({ ...response, ...response.personDetails, personDetailsId: response?.personDetails?.id })
			)
			message.success('Операция успешно выполнена')
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		}
	}
}

export const verification = ({data, payload, onSuccess}) => {
	let {flEmployer} = payload

	//TODO ID и CODE по умолчанию, используется в случае если company.id равен null для ФЛ
	const DEFAULT_ID = 123456789
	return async (dispatch) => {
		try {
			dispatch(actions.toggleLoading(true))
			const response = await api.profile.personVerification(data, flEmployer)
			dispatch(
				userActions.setUser({ ...response, ...response.personDetails, personDetailsId: response?.personDetails?.id })
			)
			const { currentBin, companies, currentFlEmployer } = response || {}
			onSuccess()
			if (currentBin && currentFlEmployer) {
				const parsedCompanies = companies.map((company) => ({
					id: company.id !== null ? company.id : DEFAULT_ID,
					rus: company.companyName,
					kz: company.companyName,
					code: String(company.id !== null ? company.id : DEFAULT_ID),
				}))
				dispatch(userActions.setEmployerCompanies(parsedCompanies))
				dispatch(
					companyActions.setCompanies(
						companies.map((company) => ({
							...company,
							id: company.id !== null ? company.id : DEFAULT_ID,
							code: String(company.id !== null ? company.id : DEFAULT_ID),
						}))
					)
				)
				const activeCompany = getFromLocalStorage('activeCompany')
				dispatch(employerProfileThunks.getCompany({ id: currentFlEmployer ? DEFAULT_ID : activeCompany?.id || null }))
			}
			message.success('Операция успешно выполнена')
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
		} finally {
			dispatch(actions.toggleLoading(false))
		}
	}
}
export const removeOked = () => {
	return async (dispatch) => {
		dispatch(handbookActions.setSingleOptions({ name: 'oked', data: null }))
	}
}

export const removeOkedUnion = () => {
	return async (dispatch) => {
		dispatch(handbookActions.setSingleOptions({ name: 'okedUnion', data: null }))
	}
}
export const removeOkedUnionIin = () => {
	return async (dispatch) => {
		dispatch(handbookActions.setSingleOptions({ name: 'okedUnionIin', data: null }))
	}
}

export const verificationSms = (body) => {
	let { data, onSuccess, onError } = body
	return async (dispatch) => {
		try {
			dispatch(actions.toggleLoading(true))
			const response = await api.profile.save(data.payload)
			dispatch(userActions.setUser({ ...data.user, ...response, personDetailsId: response?.id }))
			message.success('Операция успешно выполнена')
			onSuccess(response)
		} catch (error) {
			message.error(error.response ? error.response.data.message : t('unknown_error'))
			onError(error?.response?.data)
		} finally {
			dispatch(actions.toggleLoading(false))
		}
	}
}
